import angular from 'angular';

import ImportLocationsAngular from '@web/locations/ImportLocations/ImportLocationsAngular';

import r2a from '../../../../react/angularIntegration/r2a';
import locationsEmptyStateComponent from '../../../../react/locations/EmptyStates/LocationsEmptyStateAngular';

import locationsComponent from './locationsComponent';
import locationsGroupComponent from './locationsGroupComponent';
import manageLocationComponent from './manageLocationComponent';

const locationsModule = angular.module('sling.dashboard.manage.locations', []);

locationsModule.config(($stateProvider) => {
  $stateProvider.state('dashboard.manage.locations', {
    abstract: true,
    url: '/locations',
    template: '<ui-view></ui-view>',
  });

  $stateProvider.state('dashboard.manage.locations.list', {
    url: '',
    template:
      "<manage-locations include-archived=\"true\" column-subset=\"['name', 'address', 'timezone', 'members',  'options']\"></manage-locations>",
    data: {
      title: 'Locations',
    },
  });

  $stateProvider.state('dashboard.manage.locations.add', {
    url: '/add',
    controllerAs: 'ctrl',
    controller: function addLocationController(Authentication, PersonaCollection, RestUtils) {
      'ngInject';

      const group = {
        type: 'location',
        members: [],
        ipAddresses: [],
      };

      if (
        !Authentication.user.isAdmin &&
        !Authentication.user.orgSettings.managersCanSeeSchedulesInOtherLocations
      ) {
        group.members.push(PersonaCollection.me);
      }

      RestUtils.getGeo().then((geo) => {
        this.group = {
          ...group,
          timezone: geo.timezone,
        };
      });
    },
    template: '<manage-location ng-if="ctrl.group" group="ctrl.group"></manage-location>',
  });

  $stateProvider.state('dashboard.manage.locations.edit', {
    url: '/{groupId:[0-9]+}?tab',
    reloadOnSearch: false,
    template: `
          <manage-location
            ng-if="ctrl.group"
            group="ctrl.group"
            previous-state="ctrl.previousState"
            tab="{{ ctrl.initialTab }}">
          </manage-location>
        `,
    controller: function editLocationController(
      PersonaCollection,
      Restangular,
      $state,
      $stateParams,
      previousState
    ) {
      'ngInject';

      this.initialTab = $stateParams.tab || '';
      this.previousState = previousState;
      const group = PersonaCollection.locations.find((g) => String(g.id) === $stateParams.groupId);
      if (!group) {
        $state.go('dashboard.manage.locations.list');
      } else {
        this.group = Restangular.copy(group);
      }
    },
    controllerAs: 'ctrl',
    resolve: {
      previousState($transition$, $state) {
        const from = $transition$.from();
        return {
          name: from.name,
          params: { ...$state.params },
        };
      },
    },
  });
});

locationsModule.component('manageLocations', locationsComponent);
locationsModule.component('manageLocation', manageLocationComponent);
locationsModule.component('locationsGroup', locationsGroupComponent);
locationsModule.component('rLocationsEmptyState', r2a(locationsEmptyStateComponent));
locationsModule.component('rImportLocations', r2a(ImportLocationsAngular));

export default locationsModule.name;
